import { Stack, Box, useMediaQuery, SxProps, Theme, useTheme } from '@mui/material';
import PageTitle from '../PageTitle';

export const PageTitleWithButtons = (props: {
  title: string,
  subTitle: React.ReactNode,
  children?: React.ReactNode,
  sx?: SxProps<Theme>,
}) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.md}px)`);

  return <Stack width='100%'
    direction={isMobile ? 'column' : 'row'}
    sx={{
      justifyContent: 'space-between',
      ...props.sx,
    }}>
    <Box width={isMobile ? '100%' : 'auto'}>
      <PageTitle subTitle={props.subTitle}>{props.title}</PageTitle>
    </Box>
    <Box width={isMobile ? '100%' : 'auto'}
      sx={{
        display: 'flex',
        justifyContent: { xs: 'flex-start', md: 'flex-end' },
      }}>
      {props.children}
    </Box>
  </Stack>;
};
